
export default function Hero() {
  return (
    <section className="relative pt-32 pb-20 px-6 lg:px-12 overflow-hidden bg-gradient-to-br from-[#F5F3FF] via-white to-[#FAF5FF]">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-[#7C3AED]/20">
              <div className="w-2 h-2 bg-[#7C3AED] rounded-full animate-pulse"></div>
              <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">HIPAA-Compliant Marketing</span>
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight">
              <span className="text-gray-900">Healthcare Marketing</span>
              <br />
              <span className="text-gray-900">That Drives</span>
              <br />
              <span className="bg-gradient-to-r from-[#7C3AED] to-[#A855F7] bg-clip-text text-transparent">Patient Growth</span>
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Full-service digital marketing for healthcare and wellness providers. We specialize in HIPAA-compliant patient acquisition, automated lead nurturing, and sustainable practice growth for hormone therapy, longevity medicine, and preventive care providers.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="bg-gradient-to-r from-[#7C3AED] to-[#A855F7] text-white px-8 py-4 rounded-lg hover:from-[#6D28D9] hover:to-[#9333EA] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap inline-flex items-center gap-2 group font-medium"
              >
                <span>Book Your Strategy Call</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
              <a
                href="#automation"
                className="border-2 border-[#7C3AED] text-[#7C3AED] px-8 py-4 rounded-lg hover:bg-[#7C3AED] hover:text-white transition-all cursor-pointer whitespace-nowrap font-medium"
              >
                See Our Platform
              </a>
            </div>

            <div className="flex flex-wrap gap-8 pt-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-[#7C3AED] text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-gray-900">HIPAA-Aligned</div>
                  <div className="text-xs text-gray-600">Secure Systems</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center">
                  <i className="ri-robot-line text-[#7C3AED] text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-gray-900">100% Automated</div>
                  <div className="text-xs text-gray-600">Lead Nurturing</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center">
                  <i className="ri-user-heart-line text-[#7C3AED] text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-gray-900">Healthcare-Only</div>
                  <div className="text-xs text-gray-600">Specialized Agency</div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/8dbaa942d1f0e95f1ab687b8fd41742b.jpg"
                alt="Healthcare Practice"
                className="w-full h-auto object-cover object-top"
              />
            </div>

            <div className="absolute -top-6 -right-6 bg-white rounded-xl shadow-xl p-5 transform hover:scale-105 transition-transform">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#7C3AED] to-[#A855F7] bg-clip-text text-transparent mb-1">+285%</div>
              <div className="text-xs text-gray-600 font-medium">Patient Growth</div>
            </div>

            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-5 max-w-xs transform hover:scale-105 transition-transform">
              <div className="flex items-center gap-1 mb-2">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#7C3AED] text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-gray-700 mb-2">"Our patient volume tripled in 6 months!"</p>
              <div className="text-xs font-semibold text-gray-900">Dr. Sarah Chen, MD</div>
              <div className="text-xs text-gray-500">Hormone Therapy Clinic</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
